export default __webpack_public_path__ + "static/media/management-home-fill-icon.08a2323d.svg";